export default {
  readMoreButton: 'Read more',
  readLessButton: 'Read less',
};
